import Sblocca from "@/pages/Sblocca";

/**
 * Pagina /offerta (richiede login): mostra l'offerta early-bird se attiva, altrimenti il
 * prezzo normale. Riusa l'unlock page (offer-aware). Chi non è loggato passa dal login e
 * torna qui conservando gli utm (gestito dal wrapper di rotta + Login ?next=).
 */
export default function Offerta() {
  return <Sblocca />;
}
